import React, { Component } from "react";
import { connect } from "react-redux";
import {
  setCurrentNavPage,
  setCompositionSlidesOrder,
  setCompositionLabel,
  initDashboardComposition,
  setDashboardCompositionIsPublic,
  setDashboardIsEditable
} from "Actions";
import {
  fetchSlides,
  fetchDashboardMetadata,
  saveDashboardComposition,
  fetchComments
} from "Thunks";
import { onSuccess, onError } from "Utils";
import SimplePageHeader from "../Common/SimplePageHeader/SimplePageHeader";
import _ from "i18n";
import styles from "./DashboardCompositionPage.local.scss";
import { push } from "react-router-redux";
import SlidesList from "./SlidesList";
import DashboardDisposition from "./DashboardDisposition";
import NotFoundV2 from "../NotFound/NotFoundV2";
import { ModalConfirm } from "tamtam-components";
import classnames from "classnames";
import clonedeep from "lodash.clonedeep";

class DashboardCompositionPage extends Component {
  dashboardId;

  constructor(props) {
    super(props);
    this.state = {
      edited: false,
      metaDataFirstLoad: false,
      dashboardLabel: {
        fr: "",
        en: "",
        nl: ""
      },
      dashboardLabelBackUp: "",
      isOpenModal: false,
      selectedLanguage: "fr",
      privacyState: false
    };
    let { id } = this.props.match.params;

    // this.handleSetCompositionLabel = debounce(
    //   this.handleSetCompositionLabel,
    //   1000
    // );
    this.dashboardId = id;
  }

  handleChangeDashboardLabel = (lng, event) => {
    let { dashboardLabel } = this.state;

    let labels = clonedeep(dashboardLabel);

    labels[lng] = event.target.value;

    this.setState({
      dashboardLabel: labels
    });
    this.handleSetCompositionLabel(labels);
  };

  handleSetCompositionLabel = labels => {
    if (this.state.metaDataFirstLoad) {
      this.setState({ edited: true });
    } else {
      this.setState({ metaDataFirstLoad: true });
    }
    this.props.dispatch(setCompositionLabel(labels));
  };

  handleChangeDashboardLabelBackUp = labelBackUp => {
    this.setState({ dashboardLabelBackUp: labelBackUp.toUpperCase() });
  };

  handleBackUpCompositionLabel = lng => {
    let { dashboardLabel } = this.state;

    let labels = clonedeep(dashboardLabel);

    labels[lng] = "";

    this.setState({
      dashboardLabel: labels
    });
    this.handleSetCompositionLabel(labels);
  };
  handleSelectInputsLanguage = index => {
    this.setState({
      selectedLanguage: index
    });
  };
  componentDidMount() {
    const { dispatch, organizationUen } = this.props;
    dispatch(setCurrentNavPage("DASHBOARD_PAGE_COMPOSITION"));
    dispatch(initDashboardComposition());

    dispatch(fetchSlides());
    dispatch(fetchComments(organizationUen));

    if (this.dashboardId) {
      // get the Dashboard metadata in order to update
      dispatch(fetchDashboardMetadata(this.dashboardId)).then(() => {
        this.setState({ edited: false });
      });
    } else {
      // creating a new dashboard
    }
  }
  componentDidUpdate(prevProps, prevState) {
    const { metadataFetched, dispatch, composition } = this.props;
    if (prevProps.metadataFetched !== metadataFetched) {
      this.setState({
        privacyState: composition.isPublic
      });
      if (this.dashboardId) {
        dispatch(setCompositionLabel(composition.labels));
        this.setState({
          dashboardLabel: composition.labels
        });
      } else {
        // creating a new dashboard
      }
    }
  }

  handleChangePrivacyState = event => {
    const { dispatch } = this.props;
    this.setState({ edited: true });
    dispatch(setDashboardIsEditable(0));
    if (event.target.value == "private") {
      this.setState({
        privacyState: false
      });
      dispatch(setDashboardCompositionIsPublic(false));
    } else {
      this.setState({
        privacyState: true
      });
      dispatch(setDashboardCompositionIsPublic(true));
    }
  };

  handleCloseCompositionPage = () => {
    const { dispatch } = this.props;

    if (this.state.edited) {
      this.setState({ isOpenModal: true });
    } else {
      dispatch(push("/dashboards"));
    }
  };

  handleScrollToEdges = target => {
    const objDiv = document.getElementById("left_side");
    if (target === "TOP") {
      objDiv.scrollTop = 0;
    } else {
      objDiv.scrollTop = objDiv.scrollHeight;
    }
  };

  handleAddSlideToDashboard = id => {
    const {
      composition: { slidesOrder }
    } = this.props;

    let newOrder = [...slidesOrder];

    newOrder.push(id);

    this.setState({ edited: true });
    this.props.dispatch(setCompositionSlidesOrder(newOrder));
    setTimeout(() => {
      this.scrollAndPulse(id);
    }, 100);
  };

  handleRemoveSlideFromDashboard = id => {
    const {
      composition: { slidesOrder }
    } = this.props;

    let newOrder = [...slidesOrder];

    newOrder = newOrder.filter(t => t !== id);

    const objDiv = document.getElementById("slide_container_" + id);
    objDiv.classList.add(styles.slide_on_remove_action);

    this.setState({ edited: true });

    setTimeout(() => {
      this.props.dispatch(setCompositionSlidesOrder(newOrder));
      objDiv.classList.remove(styles.slide_on_remove_action);
    }, 500);
  };

  handleMoveToBottom = id => {
    const {
      composition: { slidesOrder }
    } = this.props;

    let newOrder = [...slidesOrder];

    newOrder.splice(newOrder.indexOf(id), 1);
    newOrder.push(id);

    // this.handleScrollToEdges("BOTTOM");
    // setTimeout(() => {
    this.setState({ edited: true });
    this.props.dispatch(setCompositionSlidesOrder(newOrder));
    // }, 100);

    this.scrollAndPulse(id);
  };

  handleMoveToTop = id => {
    const {
      composition: { slidesOrder }
    } = this.props;

    let newOrder = [...slidesOrder];

    newOrder.splice(newOrder.indexOf(id), 1);
    newOrder.unshift(id);

    // this.handleScrollToEdges("TOP");
    // setTimeout(() => {
    this.setState({ edited: true });
    this.props.dispatch(setCompositionSlidesOrder(newOrder));
    // }, 100);

    this.scrollAndPulse(id);
  };

  handleSwapDown = id => {
    const {
      composition: { slidesOrder }
    } = this.props;

    let newOrder = [...slidesOrder];

    const index = newOrder.indexOf(id);

    if (index < newOrder.length - 1) {
      let tmp = newOrder[index];
      newOrder[index] = newOrder[index + 1];
      newOrder[index + 1] = tmp;

      this.setState({ edited: true });
      this.props.dispatch(setCompositionSlidesOrder(newOrder));
    }

    this.scrollAndPulse(id);
  };

  handleSwapUp = id => {
    const {
      composition: { slidesOrder }
    } = this.props;

    let newOrder = [...slidesOrder];

    const index = newOrder.indexOf(id);

    if (index > 0) {
      let tmp = newOrder[index];
      newOrder[index] = newOrder[index - 1];
      newOrder[index - 1] = tmp;

      this.setState({ edited: true });
      this.props.dispatch(setCompositionSlidesOrder(newOrder));
    }

    this.scrollAndPulse(id);
  };

  scrollAndPulse = id => {
    setTimeout(() => {
      const objDiv = document.getElementById("slide_container_" + id);

      objDiv.scrollIntoView({
        behavior: "smooth",
        block: "center",
        inline: "nearest"
      });

      objDiv.classList.add(styles.pulse);
    }, 5);

    setTimeout(() => {
      document
        .getElementById("slide_container_" + id)
        .classList.remove(styles.pulse);
    }, 500);
  };

  handleSaveDashboardComposition = () => {
    this.props.dispatch(saveDashboardComposition(this.dashboardId)).then(
      res => {
        onSuccess(res, {
          title: _("saveSuccess"),
          body: _("readyDashAssociate")
        });
        setTimeout(() => {
          this.props.dispatch(push("/dashboards"));
        }, 500);
      },
      err => onError(err.response.data.errors[0].message)
    );
  };

  handleError = error => {
    switch (error.code) {
      case 170060:
        return (
          <NotFoundV2
            errorPageType={"ACCESS_DENIED"}
            text={`${_("accessDenied")} : ${_("dashboardNotFound")}`}
          />
        );
      case 403:
        return (
          <NotFoundV2
            errorPageType={"ACCESS_DENIED"}
            text={`${_("accessDenied")} : ${_("noRightsForOperations")}`}
          />
        );
      default:
        return (
          <NotFoundV2 errorPageType={"ACCESS_DENIED"} text={"errorOccured"} />
        );
    }
  };
  onChangeIsEditable = () => {
    const {
      dispatch,
      composition: { isEditable }
    } = this.props;
    dispatch(setDashboardIsEditable(isEditable ? 0 : 1));
    this.setState({ edited: true });
  };

  render() {
    const {
      fetching,
      fetched,
      slides,
      composition,
      saving,
      metadataFetched,
      metadataFetching,
      metaDataError,
      error,
      commentFetched,
      commentFetching,
      dispatch,
      withoutHeader,
      backOffice
    } = this.props;
    let { isOpenModal, selectedLanguage, privacyState } = this.state;
    return (
      <div>
        <SimplePageHeader
          closePage={this.handleCloseCompositionPage}
          title={_("dashboardComposition")} // secondaryButton={{
          //   label: _("preview"),
          //   icon: "EyeIcon"
          //   // action: this.showPreview
          // }}
          primaryButton={{
            label: _("save"),
            action: this.handleSaveDashboardComposition,
            saving: saving,
            isDisabled:
              !this.state.edited ||
              this.props.composition.slidesOrder.length === 0 ||
              (this.props.composition.labels["fr"].length === 0 &&
                this.props.composition.labels["en"].length === 0 &&
                this.props.composition.labels["nl"].length === 0) ||
              error
          }}
        />
        <ModalConfirm
          type={"return"}
          isOpen={isOpenModal}
          onCancel={() => this.setState({ isOpenModal: false })}
          onConfirm={() => {
            dispatch(push("/dashboards"));
          }}
          inProcess={false}
          actionFailed={false}
          title={_("exitConfirm")}
          text={_("cancelConfirmContent")}
          labelNo={_("cancel")}
          labelYes={_("exit")}
          labelError={"Error"}
        />

        {(fetching || metadataFetching) &&
          commentFetching && (
            <div className={styles.ripple_loading}>
              <img src={"/img/Ripple-1s-150px.svg"} alt="" />
            </div>
          )}

        {(metaDataError || error) &&
          this.handleError(metaDataError ? metaDataError : error)}

        {!error &&
          fetched &&
          slides &&
          (!this.dashboardId || metadataFetched) &&
          commentFetched && (
            <div>
              <div
                id={"left_side"}
                className={classnames(
                  styles.left_side,
                  withoutHeader ? styles.without_header : ""
                )}
              >
                <DashboardDisposition
                  slides={[
                    ...slides.standard,
                    ...slides.used,
                    ...(slides.created || [])
                  ]}
                  composition={composition}
                  privacyState={privacyState}
                  selectedLanguage={selectedLanguage}
                  handleScrollToEdges={this.handleScrollToEdges}
                  handleRemoveSlideFromDashboard={
                    this.handleRemoveSlideFromDashboard
                  }
                  handleMoveToBottom={this.handleMoveToBottom}
                  handleMoveToTop={this.handleMoveToTop}
                  handleSwapUp={this.handleSwapUp}
                  handleSwapDown={this.handleSwapDown}
                  handleChangeDashboardLabel={this.handleChangeDashboardLabel}
                  handleChangeDashboardLabelBackUp={
                    this.handleChangeDashboardLabelBackUp
                  }
                  handleBackUpCompositionLabel={
                    this.handleBackUpCompositionLabel
                  }
                  handleSelectInputsLanguage={this.handleSelectInputsLanguage}
                  handleChangePrivacyState={this.handleChangePrivacyState}
                  onChangeIsEditable={this.onChangeIsEditable}
                />
              </div>
              <div className={styles.right_side}>
                <div className={styles.title}>{_("slidesList")}</div>
                <SlidesList
                  slides={slides}
                  composition={composition}
                  handleAddSlideToDashboard={this.handleAddSlideToDashboard}
                  comments={this.props.comments}
                  backOffice={backOffice}
                />
              </div>
            </div>
          )}
      </div>
    );
  }
}

// Connected Component
const mapStateToProps = state => ({
  fetching: state.dashboardComposition.fetching,
  fetched: state.dashboardComposition.fetched,
  metadataFetching: state.dashboardComposition.dashboardMetadata.fetching,
  metadataFetched: state.dashboardComposition.dashboardMetadata.fetched,
  saving: state.dashboardComposition.saving,
  error: state.dashboardComposition.error,
  metaDataError: state.dashboardComposition.dashboardMetadata.error,
  slides: state.dashboardComposition.slides,
  composition: state.dashboardComposition.composition,
  comments: state.preparePresentation.items.comments,
  commentFetching: state.preparePresentation.fetching,
  commentFetched: state.preparePresentation.fetched,
  organizationUen: state.auth.currentOrganization.uen,
  withoutHeader: state.auth.withoutHeader,
  backOffice: state.params.backOffice
});

export default connect(mapStateToProps)(DashboardCompositionPage);



// WEBPACK FOOTER //
// ./src/components/DashboardComposition/DashboardCompositionPage.js